import script from "./ChatMessageAttached.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessageAttached.vue?vue&type=script&setup=true&lang=ts"

import "./ChatMessageAttached.vue?vue&type=style&index=0&id=1caab2aa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1caab2aa"]])

export default __exports__